import { fetchIssuedByData } from "@/api/profile";

export default {
  namespaced: true,
  state: {
    data: [],
    hasError: {},
  },

  mutations: {
    SET_DATA(state, payload) {
      state.data = payload;
    },
    SET_ERROR(state, status) {
      state.hasError = status;
    },
  },

  actions: {
    async loadIssuedByData({ commit }) {
      try {
        const response = await fetchIssuedByData();
        commit("SET_DATA", response.data);
      } catch (error) {
        commit("SET_ERROR", error);
        throw error;
      }
    },
  },

  getters: {
    issuedBy: (state) => state.data,
  },
};
